import { apiClient, fastApiClient } from "../App";

// ======================
// Users APIs
// ======================

// Get All Users
export const getUsers = (department, extra = {}) => {
  const params = {
    ...(department && department !== "all" ? { department } : {}),
    ...extra,
  };
  return apiClient.get("/users/", { params });
};

// Create User
export const createUser = (data) => {
  return apiClient.post("/users/", data);
};

// Update User
export const updateUser = (id, data) => {
  return apiClient.patch(`/users/${id}/`, data);
};

// Delete User
export const deleteUser = (id) => {
  return apiClient.delete(`/users/${id}/`);
};

// Bulk Import Users
export const bulkImportUsers = (data) => {
  return apiClient.post("/users/bulk-import/", data);
};

// Get All Departments
export const getDepartments = () => {
  return fastApiClient.get("/departments");
};